import React from 'react'

export default function Footer() {
    return (
        <footer className='flex justify-center items-center w-full bg-transparent text-center text-white text-xs sm:text-base py-4 font-[400]'>
            <span>&copy;2025 Monash Media</span>
            <span className='bg-white rounded-full h-1 w-1 sm:h-1.5 sm:w-1.5 mx-1 sm:mx-2'></span>
            <span>All rights reserved</span>
            <span className='bg-white rounded-full h-1 w-1 sm:h-1.5 sm:w-1.5 mx-1 sm:mx-2'></span>
            Contact us
        </footer>
    )
}

